import React from 'react'
import { LangButton, LangButtonsContainer } from './LangButtons.style'
import i18n from 'i18next'
import moment from 'moment'
import 'moment/locale/ko'

const savedLang = typeof window !== 'undefined' ? localStorage.getItem('lang') : null
moment.locale(savedLang ?? 'en');

const LangButtons: React.FC = () => {

  const changeLanguage = (lang: string) => {
    moment.locale(lang);
    localStorage.setItem('lang', lang)
    window.location.reload()
  }

  const isLang = (code: string) => {
    return i18n.language === code
  }

  return (
    <LangButtonsContainer>
      <LangButton active={isLang('ko')} onClick={() => changeLanguage('ko')}>ko</LangButton>
      <span className="mx-1">/</span>
      <LangButton active={isLang('en')} onClick={() => changeLanguage('en')}>en</LangButton>
    </LangButtonsContainer>
  )
}


export default LangButtons
